import { queryOptions, useQuery } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import { api, ApiError, companyQueryScope } from "./api";
import type { Identity, Me } from "./types";

export const identityQueryOptions = () => queryOptions({
  queryKey: ["identity"],
  queryFn: () => api<Identity>("/auth/me"),
  staleTime: 30_000,
});

export function companyMeQueryOptions(companyId: string) {
  return queryOptions({
    queryKey: [companyQueryScope(companyId), "me"],
    queryFn: async (): Promise<Me> => {
      const identity = await api<Identity>("/auth/me");
      const currentCompany = identity.companies.find((company) => company.id === companyId);
      if (!currentCompany)
        throw new ApiError(404, "not_found", "Föreningen hittades inte.");
      return { ...identity, currentCompany };
    },
    staleTime: 30_000,
  });
}

export function useCompanyId(): string {
  const params = useParams({ strict: false });
  const companyId = "companyId" in params ? params.companyId : undefined;
  if (typeof companyId !== "string" || !companyId)
    throw new Error("Välj en förening och försök igen.");
  return companyId;
}

export function useCompanyContext() {
  const companyId = useCompanyId();
  const meQuery = useQuery(companyMeQueryOptions(companyId));
  return { companyId, meQuery, currentCompany: meQuery.data?.currentCompany };
}
